import config from './config'

export default {

    install(Vue, options) {

        Vue.prototype.$css = {...config, ...options};
    }
}


